import {Divider} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {BusinessOfferSlot} from '@yandex-delivery/form/ui/OrderForm/widgets/BusinessOfferSlot'
import {BusinessPlate} from '@yandex-delivery/form/ui/OrderForm/widgets/BusinessPlate/BusinessPlate'
import type {ReactElement} from 'react'

import {type SlotWidgetConfig, WidgetType} from '../types'
import {Slot} from './Slot'

const isRadio = (type?: string): type is WidgetType.RADIO => type === WidgetType.RADIO
const isHeader = (props: SlotWidgetConfig): boolean | undefined => props.accessibility_info?.is_header
const isBusinessOfferMock = (widget_id?: string): boolean | undefined =>
  widget_id === 'cargo_c2c_order_forms_b2b_lk_cargo_offer_payment_mock_slot_widget'
const isBusinessPlate = (widget_id?: string): boolean | undefined =>
  widget_id === 'cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget'

const divider = css`
  inline-size: calc(100% + ${spacing(4)});
  transform: translateX(${spacing(-2)});
`
/**
 * Виджет слота.
 */
export const SlotWidget = (props: SlotWidgetConfig): ReactElement => {
  // Если в хвосте слота есть радиобаттон, делаем весь слот кликабельным
  if (isRadio(props.slot.trail1?.type) || isRadio(props.slot.trail2?.type) || props.slot.action) {
    return (
      <label>
        <Slot {...props} />
      </label>
    )
  }

  if (isHeader(props)) {
    return (
      <>
        <Slot {...props} />
        <Divider className={divider} />
      </>
    )
  }

  if (isBusinessOfferMock(props.widget_id)) {
    return <BusinessOfferSlot {...props} />
  }

  if (isBusinessPlate(props.widget_id)) {
    return <BusinessPlate metricaLabel={props.metrica_label} name="is_business" />
  }

  return <Slot {...props} />
}
